const initialState = {
  cityList: [],
};

export default (state = initialState, action) => {
  const { type, data } = action;

  switch(type) {
  case 'ADMIN_CITY_LIST:CITY_LIST:SET':
    return {
      ...state,
      cityList: data,
    };
  default:
    return state;
  }
}